import { Component, Input, Output, EventEmitter, ViewChild,
  TemplateRef, ContentChild, OnInit, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { NameTable } from '../../../../@models/erp/finishedProduct';
import { ApiService } from '../../../../@core/service/api.service';
import { NbPopoverDirective } from '@nebular/theme';
import { CompilationModel } from '../../../../@models/erp/compilation';
import { BusinessModel } from '../../../../@models';
import { SharedDataService } from '../../../../@core/service/shared-data.service';

@Component({
  selector: 'ngx-form-column-select',
  templateUrl: './form-column-select.component.html',
  styleUrls: ['./form-column-select.component.scss'],
})
export class FormColumnSelectComponent implements OnInit, OnChanges, OnDestroy {

  @Input() value: string = '';
  @Input() icon: string = '☰';
  @Input() compilation: CompilationModel;
  @Input() title: string = '';
  @Input() textfield: boolean = false;
  @Input() trial: boolean = false;
  @Input() baseProduct: boolean = false;
  @Input() business: string;
  // @Input() businesses: BusinessModel[];
  // @Input() finishedProductNames: NameTable[];
  @Input() disabled = false;
  @Input() initialProducts = [];
  @Output() productSelected: EventEmitter<NameTable> = new EventEmitter<NameTable>();
  @Output() onClose: EventEmitter<void> = new EventEmitter<void>();
  @ViewChild(NbPopoverDirective) popover: NbPopoverDirective;
  @ContentChild('product', { static: true }) private productRef: TemplateRef<Object>;

  // public finishedProductNames: NameTable[];
  // public static staticNames: NameTable[];

  public searchNrkProductName: string;
  public searchTrial: string;
  public searchNrkCode: string;
  public searchCustomerProductName: string;
  public searchCustomerProductCode: string;

  // public businesses: BusinessModel[];
  // public businessOptions: { id: string, name: string }[] = [];
  // public business: string;

  private subscriptions = [];

  sort = -1;

  isShown = false;

  headProducts: any = [];

  constructor(
    // private api: ApiService,
    public data: SharedDataService,
  ) {
  }


  async ngOnInit(): Promise<void> {
    // this.finishedProductNames || this.finishedProductNames = await this.api.loadFinishedProductNames();
    // this.businesses || this.subscriptions.push(this.api.reloadBusiness({active: true}).subscribe( b => {
    //   this.businesses = b;
    //   this.businessOptions = this.businesses.map(m => ({ id: m._id, name: m.name }));
    //   this.setBusiness();
    // }));
    await this.data.loadBusinesses();
    if (!this.baseProduct) this.value = '---- All ----';
    // console.log('this.initialProductsini', this.initialProducts);
    if (this.initialProducts && this.initialProducts.length) this.headProducts = this.initialProducts;
  }

  ngOnChanges(sc: SimpleChanges) {
    if (sc.businesses && sc.businesses.currentValue) {
      // this.businessOptions = this.data.businesses.map(m => ({ id: m._id, name: m.name }));
      this.setBusiness();
    }
    // console.log('this.initialProductsch', this.initialProducts);
    if (this.initialProducts && this.initialProducts.length) this.headProducts = this.initialProducts;
  }

  ngOnDestroy() {
    this.subscriptions.forEach(el => el.unsubscribe());
  }

  setBusiness() {
    if (this.compilation && this.compilation.recipient) this.business = this.compilation.recipient.toString();
  }

  onDocClick(event) {
    const el = document.getElementsByTagName('nb-popover')[0];
    const er = el.getBoundingClientRect();
    const tr = event.target.getBoundingClientRect();
    if (tr.width !== 0 && tr.height !== 0 && !(er.left <= tr.left && tr.left <= er.left + er.width &&
        er.top <= tr.top && tr.top <= er.top + er.height)) {
      if (this.isShown  ) {
        this.popover.hide();
        this.isShown = false;
      }
    }
  }

  async onClick(event) {
    if (this.isShown) {
      this.popover.hide();
      this.isShown = false;
    } else {
      event.stopPropagation();
      this.popover.show();
      this.isShown = true;
    }
  }

  onClosePopup() {
    this.popover.hide();
    this.isShown = false;
  }

  getBusinessOptions() {
    return this.data.finishedProductNames && this.data.finishedProductNames.map(m => m.business)
      .filter((f, idx, self) => f != null && f.length > 0 && self.indexOf(f) === idx)
      .sort((a, b) => a > b ? 1 : -1)
      .map(m => ({ id: m, name: m }));
  }

  onSelectRow(idx) {
    this.popover.hide();
    this.isShown = false;
    const item = this.filter(
      this.searchNrkProductName,
      this.searchTrial,
      this.searchNrkCode,
      this.searchCustomerProductName,
      this.searchCustomerProductCode,
      this.business,
    )[idx];
    this.productSelected.emit(item)
    if (this.trial) {
      this.value = item.trial;
    } else if (this.baseProduct) {
      this.value = item.baseCode;
    } else {
      this.value = item.calcName;
    } 
  }

  onSort(field: string) {
    this.data.finishedProductNames = this.data.finishedProductNames.sort((a, b) => {
      const astr = a[field] ? a[field].toLowerCase() : '';
      const bstr = b[field] ? b[field].toLowerCase() : '';
      return astr < bstr ? this.sort : -this.sort;
    });
    this.sort = -this.sort;
  }

  filterBusiness(/* business: string */) {
    this.searchNrkProductName = null;
    this.searchTrial = null;
    this.searchNrkCode = null;
    this.searchCustomerProductName = null;
    this.searchCustomerProductCode = null;
  }

  filter(pns, pts, pcs, cns, ccs, bs) {
    let names = this.data.finishedProductNames;
    if (bs && bs.length > 0) {
      // names = names.filter(f => (f.business && f.business.toLowerCase().includes(bs.toLowerCase())));
      names = names.filter(f => f.business && (f.allBusinesses || f.business.includes(bs)))
    }
    if (pts && pts.length > 0) {
      names = names.filter(f => (f.trial?.toLowerCase().includes(pts.toLowerCase())));
    }
    if (pns && pns.length > 0) {
      names = names.filter(f => (f.nrkName?.toLowerCase().includes(pns.toLowerCase())));
    }
    if (pcs && pcs.length > 0) {
      names = names.filter(f => (f.nrkCode?.toLowerCase().includes(pcs.toLowerCase())));
    }
    if (cns && cns.length > 0) {
      names = names.filter(f => (f.customerName?.toLowerCase().includes(cns.toLowerCase())));
    }
    if (ccs && ccs.length > 0) {
      names = names.filter(f => (f.customerCode?.toLowerCase().includes(ccs.toLowerCase())));
    }
    if (names == this.data.finishedProductNames && this.initialProducts) {
      // return  [...names.filter(f => this.initialProducts.indexOf(f.id) >= 0)];
      return this.initialProducts.map(m => names.find(f => f.id === m)).filter(notNull => notNull);
    }
    return names;
  }

  getBp(value) {
    return (this.data?.finishedProductNames?.find(f => f.baseCode === value) || {})['bpName'];
  }

}
